import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { empModulo } from '../../../diccionarios/empModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ReportesService } from '../../../services/administrador/reportes.service';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';
import { EmpresasModel } from '../../../models/empresasModel';

@Component({
  selector: 'app-reporte-horas',
  templateUrl: './reporte-horas.component.html',
  styleUrls: ['./reporte-horas.component.css']
})
export class ReporteHorasComponent implements OnInit {


  empModulo: any = {};
  loading: boolean = false;
  listaVacia: boolean = true;
  mostrarCard: boolean = true;
  resposiveFull: string;

  columnDefs: any[];//aggrid
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  textoBuscar: string;
  
  dataEdit: any = {};
  arrayEdit: any[] = [];

  constructor(private fb: FormBuilder, private _util: UtilsService, private _reporteService: ReportesService,  private _crearEmpleado: CrearEmpleadoService) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.cargarGrid();
    this.getData();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Acceso',
        field: 'acceoIESS',
        sortable: true,
        width: 170,
        filter: true,
        cellStyle: this.changeRowColor.bind(this),
      },
      {
        headerName: 'Cédula',
        field: 'codEmpleado',
        filter: true,
        width: 180,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombres',
        field: 'nombres',
        sortable: true,
        filter: true,
        width: 250,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cod.Empresa',
        field: 'empresa.codEmpresa',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      
      {
        headerName: 'Empresa',
        field: 'empresa.descripcion',
        sortable: true,
        width: 180,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Pri.Contrato',
        field: 'fechaPrimerContrato',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha último Contrato',
        field: 'fechaUltimoContrato',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'F.Creación',
        field: 'fechaCreacion',
        sortable: true,
        width: 200,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'F.Modulo SSTMA',
        field: 'fechaModuloSSTMA',
        sortable: true,
        width: 200,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'F.Aprobación SSTMA',
        field: 'fechaAccesoIESS',
        sortable: true,
        width: 200,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'F.Rechazo SSTMA',
        field: 'fechaRechazoSSTMA',
        sortable: true,
        width: 200,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Observación',
        field: 'observacion',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.acceoIESS != undefined) {
      if (data.acceoIESS === 'Inactivo') {
        return {
          'background-color': '#F1948A',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      } else {
        return {
          'background-color': '#52BE80',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false;
  }
  getData() {
    //getAllEmpleadoEmpresa
    this.loading = true;
    this._crearEmpleado.getReporteHoras().subscribe((res: any[]) => {
      this.rowData = res;
      this.loading = false;
      this.listaVacia = (res.length === 0 ) ? true : false;
    }, (err) => {
      this.rowData = [];
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.message, 2000);
      console.log(err);
    });
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  descargar() {
    this._crearEmpleado.descargarDocumento().subscribe((res:any)=>{
      console.log(res);
      this._util.descargarArchivo(res.clave, res.valor);
    },(err:any)=>{
      this._util.mensajeErroToast(err.error.message, 2000);
    });
  }
  // descargarDocumento
}
